export const getLocalStorage = (key: string) => {
	if (window !== undefined) {
		const value = localStorage.getItem(key);
		return value && value !== 'undefined' ? JSON.parse(value) : null;
	}
};

export const setLocalStorage = (key: string, value: any) => {
	if (window !== undefined) {
		localStorage.setItem(key, JSON.stringify(value));
	}
};

export const deleteLocalStorage = (key: string) => {
	localStorage.removeItem(key);
};
